module.exports={
  "id": "salads-and-sandwiches",
  "name": "Salads and sandwiches",
  "badge": "Great for big groups",
  "subtext": "These classic, hearty picks are perfect for a midday refuel.",
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/fltdqct5n5d9laqemqnv.jpg",
  "price": {
    "value": 29.0,
    "per_person": true
  },
  "menu": {
    "menu_sections": [
      {
        "id": "salads-selections",
        "title": "Salads (select 1)",
        "min_selections": 1,
        "max_selections": 1,
        "items": [
          {
            "name": "Seasonal mixed greens",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Caprese with mozzarella and tomatoes",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Caesar with parmesan and herbed croutons",
            "price": {
              "value": 0.0
            }
          }
        ]
      },
      {
        "id": "sandwiches-selections",
        "title": "Gourment sandwiches (select up to 3)",
        "min_selections": 1,
        "max_selections": 3,
        "items": [
          {
            "name": "Italian sub",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Chicken salad sandwich",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Turkey croissant with swiss",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Caprese ciabatta with pesto",
            "price": {
              "value": 0.0
            }
          }
        ]
      }
    ]
  },
  "description": "Your pick of salads and sandwiches to fuel up all of your attendees including: caprese and caesar salads, italian subs, chicken salad sandwich, and more."
}
